import { useEffect, useRef, useState } from "react";
import { DateRangePicker } from "rsuite"
import Select from 'react-select';
import { format } from 'date-fns';
import {
    setDateRangeValue, setSelectedEmployee, setSelectedProject, getAllExpenseEntryApprovalsAsync, setIsIncludeDateRange, setIsRemoveFilterSetting
} from './ExpenseApprovalSlice'
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat, getValueFromResource, dateFormatByAccountCultureForFilters } from '../../../common/timeLiveFunction';
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import DatePickerRanges from "../../../common/DatePickerRanges";

const ExpenseApprovalFilter = (props: any) => {
    const { t } = props;
    const { Projectdata, Employeesdata, currentPage, pageSize, start, direction, columnIndex, includeDateRange, startExpenseApprovalDate, endExpenseApprovalDate } = useAppSelector((state) => state.expenseApproval);
    const { maxMenuHeight, sessionAccountEmployeeId, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat } = useAppSelector((state) => state.globalState);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const currentDate = new Date();
    const [SelectedStartDate, setSelectedStartDate] = useState(() => {
        const newDate = new Date();
        newDate.setMonth(newDate.getMonth() - 2);
        return newDate;
    });
    const [SelectedEndDate, setSelectedEndDate] = useState(currentDate);
    const [includechecked, setIncludeChecked] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const dispatch = useAppDispatch();
    const [filterValues, setFilterValues] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState(
        Employeesdata.filter((item: any) => item.isSelected === 1).map((item: any) => ({
            value: item.value,
            label: item.label,
        }))
    );
    const [selectedProjects, setSelectedProjects] = useState(
        Projectdata.filter((item: any) => item.isSelected === 1).map((item: any) => ({
            value: item.value,
            label: item.label,
        }))
    );
    const [displayedRange, setDisplayedRange] = useState('Please Select Date Range');

    useEffect(() => {
        if (selectedEmployees.length === 0) {
            setSelectedEmployees(
                Employeesdata.filter((item: any) => item.isSelected === 1).map((item: any) => ({
                    value: item.value,
                    label: item.label,
                }))
            );
        }
    }, [Employeesdata]);

    useEffect(() => {
        if (selectedProjects.length === 0) {
            setSelectedProjects(
                Projectdata.filter((item: any) => item.isSelected === 1).map((item: any) => ({
                    value: item.value,
                    label: item.label,
                }))
            );
        }
    }, [Projectdata]);

    const handleEmployeeOptionChange = (selectedOption: any) => {
        const values = selectedOption.map((option: any) => option.value);
        dispatch(setSelectedEmployee({ values }));
    }

    const handleProjectOptionChange = (selectedOption: any) => {
        const values = selectedOption.map((option: any) => option.value);
        dispatch(setSelectedProject({ values }));
    }

    const handleDateRangeChange = (value: any) => {
        if (value !== undefined && value !== null) {
            // setSelectedStartDate(value[0]);
            // setSelectedEndDate(value[1]);
            // // setStartDate(value[0]);
            // // setEndDate(value[1]);
            // dispatch(setDateRangeValue({ startDate: value[0].toISOString(), endDate: value[1].toISOString() }));
            if (value && value[0] && value[1]) {
                const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
                const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
                setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
            } else {
                setDisplayedRange('Please Select Date Range');
            }
            // setSelectedStartDate(dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()));
            // setSelectedEndDate(dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()));
            // dispatch(setDateRangeValue({ startDate: dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()), endDate: dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()) }));
            setSelectedStartDate(dateFormatByAccountCultureForFilters(format(value[0], "yyyy-MM-dd"), cultureInfoName.toString()));
            setSelectedEndDate(dateFormatByAccountCultureForFilters(format(value[1], "yyyy-MM-dd"), cultureInfoName.toString()));
            dispatch(setDateRangeValue({ startDate: format(value[0], "yyyy-MM-dd"), endDate: format(value[1], "yyyy-MM-dd") }));
        }
    }

    const handleResetFiltersOnClickEvent = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
        const newDate = new Date();
        newDate.setMonth(newDate.getMonth() - 2);
        setStartDate(newDate);
        setSelectedStartDate(newDate);
        setEndDate(new Date());
        setSelectedEndDate(new Date());
        setIncludeChecked(false)
        dispatch(setIsIncludeDateRange(false));
        let approverEmployeeId: Number = 0;
        if (sessionAccountEmployeeId) {
            approverEmployeeId = sessionAccountEmployeeId;
        }
        setSelectedEmployees([]);
        setSelectedProjects([]);
        const commaSeparatedEmployeeValues = "0";
        const commaSeparatedProjectValues = "0";
        let SearchParamsValues = { page: currentPage, pageSize: pageSize, start: start, Order: columnIndex, OrderDir: direction, search: " ", StartDate: `${moment(newDate).format(dateInsertionFormat)}`, EndDate: `${moment(new Date()).format(dateInsertionFormat)}`, EmployeeValues: `${commaSeparatedEmployeeValues}`, ProjectValues: `${commaSeparatedProjectValues}`, includeDateRange: `${includeDateRange}`, ApproverEmployeeId: `${approverEmployeeId}` };
        dispatch(getAllExpenseEntryApprovalsAsync(SearchParamsValues));
    }

    const handleApplyFilterOnClickEvent = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
        const commaSeparatedEmployeeValues = Employeesdata.some((item: any) => item.isSelected === 1) ? Employeesdata.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ') : "0";
        const commaSeparatedProjectValues = Projectdata.some((item: any) => item.isSelected === 1) ? Projectdata.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ') : "0";
        let SearchParamsValues = { page: currentPage, pageSize: pageSize, start: start, Order: columnIndex, OrderDir: direction, search: " ", StartDate: `${moment(SelectedStartDate).format(dateInsertionFormat)}`, EndDate: `${moment(SelectedEndDate).format(dateInsertionFormat)}`, EmployeeValues: `${commaSeparatedEmployeeValues}`, ProjectValues: `${commaSeparatedProjectValues}`, includeDateRange: `${includeDateRange}`, ApproverEmployeeId: `${sessionAccountEmployeeId}` };
        dispatch(getAllExpenseEntryApprovalsAsync(SearchParamsValues))
            .unwrap()
            .then((originalPromiseResult) => {
                dispatch(setIsRemoveFilterSetting(false));

            })
            .catch((rejectedValueOrSerializedError) => {
            });
    }

    const handleIncludeDateRangeChange = (e: any) => {
        setIncludeChecked(e.target.checked)
        dispatch(setIsIncludeDateRange(e.target.checked));
    }

    return (
        <>
            <div className='card-body'>
                <div className='row'>
                    <div className="col-md-12">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Date Range')} */}
                            {getValueFromResource('Date Range',dispatch, t)}
                            </label>
                        <DateRangePicker
                            onChange={handleDateRangeChange}
                            ranges={DatePickerRanges() }
                            // value={[new Date(startExpenseApprovalDate), new Date(endExpenseApprovalDate)]}
                            value={[SelectedStartDate, SelectedEndDate]}
                            // placeholder={t('Please Select Date Range')}
                            placeholder={displayedRange}
                            character={' - '}
                            cleanable={false}
                            placement="bottomEnd"
                            format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                        >
                        </DateRangePicker>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12 mt-6'>
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Employee Name')} */}
                            {getValueFromResource('Employee Name',dispatch, t)}
                            </label>
                        {/* <div>
                            <Select
                                placeholder={t('Select')}
                                isSearchable={true}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                isMulti
                                onChange={(selectedOption) => {
                                    handleEmployeeOptionChange(selectedOption);
                                }}
                                value={Employeesdata.filter((item: any) => item.isSelected == 1).map((item: any) => ({ value: item.value, label: item.label }))}                               
                                options={Employeesdata.map((item: any) => ({
                                    value: item.value,
                                    label: item.label,
                                }))}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            /> */}
                        <Select
                            placeholder=
                            // {t('Select')}
                            {getValueFromResource('Select',dispatch, t)}
                            isSearchable={true}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            isMulti
                            onChange={(selectedOption: any) => {
                                setSelectedEmployees(selectedOption); // Update local state on change
                                handleEmployeeOptionChange(selectedOption);
                            }}
                            value={selectedEmployees} // Bind to component value
                            options={Employeesdata.map((item: any) => ({
                                value: item.value,
                                label: item.label,
                            }))}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12 mt-6'>
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Projects')} */}
                            {getValueFromResource('Projects',dispatch, t)}
                            </label>
                        <div>
                            {/* <Select
                                placeholder={t('Select')}
                                isSearchable={true}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                isMulti
                                onChange={(selectedOption) => {
                                    handleProjectOptionChange(selectedOption);
                                }}
                                value={Projectdata.filter((item: any) => item.isSelected == 1).map((item: any) => ({ value: item.value, label: item.label }))}
                                options={Projectdata.map((item: any) => ({
                                    value: item.value,
                                    label: item.label,
                                }))}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            /> */}
                            <Select
                                placeholder=
                                // {t('Select')}
                                {getValueFromResource('Select',dispatch, t)}
                                isSearchable={true}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                isMulti
                                onChange={(selectedOption: any) => {
                                    setSelectedProjects(selectedOption); // Update local state on change
                                    handleProjectOptionChange(selectedOption);
                                }}
                                value={selectedProjects} // Bind to component value
                                options={Projectdata.map((item: any) => ({
                                    value: item.value,
                                    label: item.label,
                                }))}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-md-12 mt-6">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Include Date Range')} */}
                            {getValueFromResource('Include Date Range',dispatch, t)}
                            </label>
                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                            <input 
                            className="form-check-input h-20px w-30px"
                                type="checkbox"
                                checked={includechecked}
                                onChange={(e: any) => handleIncludeDateRangeChange(e)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='card-footer pt-4'>
                <div className='d-flex flex-stack float-end'>
                    <div className='d-flex align-items-center me-2'>
                        <button
                            type='button'
                            ref={closeButtonRef}
                            style={{ display: 'none' }}
                            id='kt_OffCanvas_close'
                        >
                            {/* {t('Apply Filter')} */}
                            {getValueFromResource('Apply Filter',dispatch, t)}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm me-2 fs-7"
                            data-kt-element='send'
                            onClick={handleResetFiltersOnClickEvent}
                        >
                            {/* {t('Reset Filters')} */}
                            {getValueFromResource('Reset Filters',dispatch, t)}
                        </button>
                        <button
                            type="button"
                            data-kt-element='send'
                            className="btn btn-primary btn-sm fs-7"
                            onClick={handleApplyFilterOnClickEvent}
                        >
                            <i className="bi bi-filter fs-5 me-1"></i>
                            {/* {t('Apply Filters')} */}
                            {getValueFromResource('Apply Filters',dispatch, t)}
                            </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ExpenseApprovalFilter;